var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[(!_vm.isMobile)?_c('Header'):_c('MHeader'),_c('div',{class:_vm.isMobile ? 'router-view mobile-view' : 'router-view'},[_c('router-view')],1),(!_vm.isMobile)?_c('Footer'):_c('MFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }